import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { GUARANTEED } from '../logic/common/state'
type Refresh = () => void

interface registerReturnParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingRegisterReturnItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmRegisterReturn: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenRegisterReturnModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const registerReturn = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setLoadingRegisterReturnItem,
  setNameReserve,
  setHashItemReserve,
  setConfirmRegisterReturn,
  setOpenRegisterReturnModal,
}: registerReturnParams): Promise<void> => {
  try {
    setLoadingRegisterReturnItem(true)
    setOpenRegisterReturnModal && setOpenRegisterReturnModal(false)
    let status = null
    status = await itemServices.register_return(hashItemReserve)
    
    if (status == 200) {
      notify('ra.notification.register_return_success', {
        type: 'success',
        messageArgs: { item: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmRegisterReturn && setConfirmRegisterReturn(false)
      setLoadingRegisterReturnItem(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmRegisterReturn && setConfirmRegisterReturn(false)
    setLoadingRegisterReturnItem(false)
    notify('ra.notification.register_return_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
  } catch (error) {
    notify('ra.notification.register_return_error', {
      type: 'error',
      messageArgs: { item: nameReserve },
    })
    setNameReserve('')
    setHashItemReserve('')
    setLoadingRegisterReturnItem(false)
    setConfirmRegisterReturn && setConfirmRegisterReturn(false)
    setOpenRegisterReturnModal && setOpenRegisterReturnModal(false)
  } finally {
    customAwait([refresh])
  }
}